import React from 'react';
import { Controller } from 'react-hook-form';
import { Input } from '..';

const AccountNumberInput = ({ name, control, displayName, required, placeholder, errors }) => {
  return <Controller
    name={name}
    control={control}
    rules={{
      required: required ? `${displayName} is required` : null,
      pattern: {
        value: /^[0-9]{8}$/,
        message: "Invalid UK bank account number. it must be 8 digits",
      },
    }}
    render={({ field: { onChange, ...field } }) => (
      <Input
        {...field}
        className="fs-7-tight py-2"
        placeholder={placeholder ?? "12345678"}
        invalid={!!errors}
        onChange={(e) => {
          const value = e.target.value.replace(/\D/g, '');
          onChange(value);
        }}
      />
    )}
  />
}

export default AccountNumberInput;